export enum ProcedureValidationErrorType {
  NON_UNIQUE_NAME = 'NON_UNIQUE_NAME',
  INVALID_NAME = 'INVALID_NAME',
  DELETED_PARAMETER = 'DELETED_PARAMETER',
  INVALID_PARAMETER_RANGE = 'INVALID_PARAMETER_RANGE',
  INVALID_SCHEMA_FOR_PARAMETER_TYPE = 'INVALID_SCHEMA_FOR_PARAMETER_TYPE',
  SETPOINT_NOT_IN_RANGE = 'SETPOINT_NOT_IN_RANGE',
  UPSTREAM_MATERIAL_EDGE = 'UPSTREAM_MATERIAL_EDGE',
  INDIRECT_MATERIAL_EDGE = 'INDIRECT_MATERIAL_EDGE',
  MISSING_MATERIAL_OUTPUT_TYPE = 'MISSING_MATERIAL_OUTPUT_TYPE',
  ARCHIVED_SCHEMA = 'ARCHIVED_SCHEMA',
  ARCHIVED_MODEL_ENTITY_SCHEMA = 'ARCHIVED_MODEL_ENTITY_SCHEMA',
  MISMATCHED_VALUE_TYPE = 'MISMATCHED_VALUE_TYPE',
  MISMATCH_MODELS_TYPE = 'MISMATCH_MODELS_TYPE',
  NEGATIVE_AMOUNT = 'NEGATIVE_AMOUNT',
  PROCEDURE_PRODUCT_LIMITS = 'PROCEDURE_PRODUCT_LIMITS',
  NON_ENTITY_MATERIAL_INPUT_CONFIRMED_VIA_PLATE_MAP = 'NON_ENTITY_MATERIAL_INPUT_CONFIRMED_VIA_PLATE_MAP',
  UNCONTAINABLE_SCHEMA_ON_MATERIAL_INPUT_CONFIRMED_VIA_PLATE_MAP = 'UNCONTAINABLE_SCHEMA_ON_MATERIAL_INPUT_CONFIRMED_VIA_PLATE_MAP',
  DUPLICATE_TEST_DEFINITION = 'DUPLICATE_TEST_DEFINITION',
  DUPLICATE_DILUTION_FACTOR = 'DUPLICATE_DILUTION_FACTOR',
  INVALID_DILUTION_FACTOR = 'INVALID_DILUTION_FACTOR',
  DILUTION_PLAN_WITHOUT_TEST_DEFINITIONS = 'DILUTION_PLAN_WITHOUT_TEST_DEFINITIONS',
  INVALID_DILUTION_ASSIGNMENT = 'INVALID_DILUTION_ASSIGNMENT',
  NO_UNIT_OPERATIONS = 'NO_UNIT_OPERATIONS',
  PARAMETER_LIBRARY_LINK_REQUIRED = 'PARAMETER_LIBRARY_LINK_REQUIRED',
  PARAMETER_LIBRARY_LINK_DISALLOWED = 'PARAMETER_LIBRARY_LINK_DISALLOWED',
  ARCHIVED_LIBRARY_PARAMETER_DEFINITION = 'ARCHIVED_LIBRARY_PARAMETER_DEFINITION',
}

export enum ProcedureValidationObjectType {
  PROCEDURE = 'PROCEDURE',
  METHOD = 'METHOD',
  MATERIAL_INPUT = 'MATERIAL_INPUT',
  MATERIAL_OUTPUT = 'MATERIAL_OUTPUT',
  DATA_PARAMETER = 'DATA_PARAMETER',
  EQUIPMENT = 'EQUIPMENT',
  MATERIAL_EDGE = 'MATERIAL_EDGE',
  STEP = 'STEP',
  TEST_DEFINITION = 'TEST_DEFINITION',
  DILUTION_PLAN = 'DILUTION_PLAN',
  /**
   * Catch-all for cases where a processes validation error is not mapped to a procedure validation object type.
   * This is used when converting ProcessFlowchartValidationErrors back to ProcedureValidationErrors.
   * TODO(BNCH-141566): This can be removed once MethodEditor is migrated to handle ProcessFlowchartValidationErrors directly.
   */
  UNKNOWN = 'UNKNOWN',
}

export const VALIDATION_ERROR_WITH_NO_DISPLAYED_OBJECT = 'never';

export interface ProcedureValidationObject {
  // This value is the cid if the object in question has a cid
  id: string | typeof VALIDATION_ERROR_WITH_NO_DISPLAYED_OBJECT;
  objectType: ProcedureValidationObjectType;
}

export interface ProcedureValidationError {
  errorMessage: string;
  type: ProcedureValidationErrorType;
  primaryObject: ProcedureValidationObject;
  parentObjects: Array<ProcedureValidationObject>;
}

// Map of validation error message to the number of times that error occurs for
// a particular object
interface CountByErrorMessage {
  [errorMessage: string]: number;
}

export interface ProcedureValidationErrorsForPanel {
  // Errors that are associated with the flowchart as a whole, rather than a
  // specific method or step
  flowchartErrorCounts: CountByErrorMessage;
  // Errors that are associated with a particular method, keyed by the method's cid
  methodErrorCountsByMethodCid: {[methodCid: string]: CountByErrorMessage};
}

export interface ProcedureValidationErrorsFilterCriteria {
  errorTypes?: Array<ProcedureValidationErrorType>;
  primaryObjectType?: ProcedureValidationObjectType;
  primaryObjectId?: string;
  parentObjectType?: ProcedureValidationObjectType;
  parentObjectId?: string;
}
